import { NgModule } from '@angular/core';
import { RadioGroupComponent } from './radio-group.component';
import { RadioButtonComponent } from './radio-button.component';

const MODULES = [RadioGroupComponent, RadioButtonComponent];

@NgModule({
  imports: [...MODULES],
  exports: [...MODULES]
})
export class RadioModule {}
